import api from '../../../connections/api';
import routes_api from '../../../connections/routes_api';

export async function fetchPlannerGoogleStatus() {
  const { data } = await api.get(routes_api.planner_google_status);
  return data;
}

/** @param {{ popup?: boolean }} opts — quando true, o callback Django devolve HTML “Fechar” e dá reload em window.opener */
export async function startPlannerGoogleOAuth(opts = {}) {
  const params = opts.popup ? { popup: 1 } : {};
  const { data } = await api.get(routes_api.planner_google_oauth_start, { params });
  return data?.authorization_url;
}

export async function disconnectPlannerGoogle() {
  await api.post(routes_api.planner_google_disconnect);
}

export async function listPlannerGoogleRemoteCalendars() {
  const { data } = await api.get(routes_api.planner_google_remote_calendars);
  return data;
}

/** @param {{ local_calendar_id?: number|string, summary?: string, google_calendar_id?: string }} body */
export async function createPlannerGoogleRemoteCalendar(body) {
  const { data } = await api.post(routes_api.planner_google_create_remote_calendar, body);
  return data;
}

/** @param {{ calendar_id?: number|string }} body — omit to sync all linked calendars */
export async function plannerGoogleManualSync(body = {}) {
  const { data } = await api.post(routes_api.planner_google_sync_manual, body);
  return data;
}
